import React, { useState, useEffect } from "react";
import { MenuItem, FormHelperText, Select, FormControl } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../../assets/customdropdown.css";

function CustomDropdown({
  selected,
  items,
  label,
  handleChange,
  isEdit,
  darkModeChange,
  required
}) {
  const [selectedvalue, setSelectedvalue] = useState(selected ? selected : 0);
  const [isError, setIsError] = useState(false);

  const handleChangeValue = (event) => {
    const value = event?.target?.value;
    setSelectedvalue(value);
    handleChange(value);
    setIsError(false);
  };
   useEffect(() => {
    if (required && selectedvalue === 0 ) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [required]);

  return (
    <div className="custom-dropdown">
      <FormControl variant="filled" style={{ minWidth: 120 }} disabled={isEdit} error={isError}>
        {/* <InputLabel id="demo-simple-select-filled-label">{label}</InputLabel> */}
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={selectedvalue}
          onChange={handleChangeValue}
          className="custom-select"
          IconComponent={() => <ExpandMoreIcon />}
          required={required}
        >
          {items?.map((item, index) => {
            return (
              <MenuItem key={index} value={item?.value}>
                {item?.label}
              </MenuItem>
            );
          })}
        </Select>
         {isError && <FormHelperText>Not dispensed reason is a required field.</FormHelperText>}
      </FormControl>
    </div>
  );
}

export default CustomDropdown;
